import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import Link from "next/link";
import React from "react";

const SearchJSX = ({ heading, array, newDesignConfig }) => {
  return (
    <div id={`search-container-${heading.split(' ').join('-').toLowerCase()}`} className="flex flex-wrap items-center gap-2 my-2">
      <b
        id={`search-container-${heading.split(' ').join('-').toLowerCase()}`}
        className={`font-semibold text-xs ${
          newDesignConfig && "text-nivabupa-blue-ethinosPlanRecommendation"
        }`}
      >{`${heading} - `}</b>
      {array.map((search, index) => (
        <div key={index} id={`search-item-${search.name.split(' ').join('-').toLowerCase()}-${heading.split(' ').join('-').toLowerCase()}`} className="flex items-center gap-4">
          <a
            className={`text-xs ${
              newDesignConfig ? "text-black" : "text-nivabupa-blue-light"
            } whitespace-nowrap truncate overflow-hidden text-ellipsis`}
            id={`search-item-${search.name.split(' ').join('-').toLowerCase()}-${heading.split(' ').join('-').toLowerCase()}`}
            href={search.link}
            title={search.name}
          >
            {search.name}
          </a>
          {index !== array.length - 1 && (
            <p className="text-xs text-gray-500"
            id={`search-item-${search.name.split(' ').join('-').toLowerCase()}-${heading.split(' ').join('-').toLowerCase()}`}>
            |</p>
          )}
        </div>
      ))}
    </div>
  );
};

const PopularSearches = ({ newDesignConfig, searchesData }: any) => {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  const searches = {
    "Health Insurance": [
      {
        name: "Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Health Insurance Plans",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Medical Insurance",
        link: "https://www.nivabupa.com/health-Insurance/health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance Plans",
        link: "https://www.nivabupa.com/health-Insurance/health-insurance-plans.html",
      },
      {
        name: "Health Insurance Policy",
        link: "https://www.nivabupa.com/health-Insurance/health-insurance-plans.html",
      },
      {
        name: "Best Family Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/family-health-insurance-plans.html",
      },
      {
        name: "Best Mediclaim Policy",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance In India",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Best Medical Insurance In India",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },

      {
        name: "Best Health Insurance Plans In India",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance Policy In India",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Mediclaim",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-mediclaim.html",
      },
      {
        name: "Best Health Insurance For Senior Citizens In India",
        link: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
      },
      {
        name: "Best Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Health Insurance With OPD Cover",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-with-opd-cover.html",
      },
      {
        name: "Mediclaim Insurance",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Medical Insurance Plans",
        link: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance Company in India",
        link: "https://www.nivabupa.com",
        
      },
      {
        name: "Critical Illness Insurance",
        link: "https://www.nivabupa.com/health-insurance/critical-illness-insurance.html",
      },
      {
        name: "Personal Accident Insurance",
        link: "https://www.nivabupa.com/health-insurance/personal-accident-insurance.html",
      },
      {
        name: "Mediclaim Policy",
        link: "https://www.nivabupa.com/health-insurance/mediclaim.html",
      },
      {
        name: "Individual Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/individual-health-insurance-plans.html",

      },
      {
        name: "Pregnancy Insurance",
        link: "https://www.nivabupa.com/health-insurance/maternity-health-insurance.html",
      },
      {
        name: "Maternity Insurance",
        link: "https://www.nivabupa.com/health-insurance/maternity-health-insurance.html",
      },
      {
        name: "Best Family Health Insurance plans in India",
        link: "https://www.nivabupa.com/health-insurance/family-health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance company",
        link: "https://www.nivabupa.com",
      },
      {
        name: "Family Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/family-health-insurance-plans.html",
      },
      {
        name: "Best Health Insurance plans for Senior Citizens",
        link: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
      },
      {
        name: "NRI Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/nri.html",
      },
      {
        name: "Mediclaim Policy for Family",
        link: "https://www.nivabupa.com/health-insurance/family-health-insurance-plans.html",
      },
      {
        name: "3 Lakh Health Insurance",
        link: "https://www.nivabupa.com/health-insurance/3-lakh-health-insurance-plans.html",
      },
      {
        name: "Health Insurance in Kerala",
        link: "https://www.nivabupa.com/health-insurance/kerala.html",
      },
      {
        name: "Health Insurance in Tamil Nadu",
        link: "https://www.nivabupa.com/health-insurance/tamil-nadu.html",
      },
      {
        name: "Health Insurance in West Bengal",
        link: "https://www.nivabupa.com/health-insurance/west-bengal.html",
      },
       {
        name: "Health Insurance in Delhi",
        link: "https://www.nivabupa.com/health-insurance/delhi.html",
      },
       {
        name: "Health Insurance in Jaipu",
        link: "https://www.nivabupa.com/health-insurance/jaipur.html",
      },
       {
        name: "Health Insurance in Lucknow",
        link: "https://www.nivabupa.com/health-insurance/lucknow.html",
      },
       {
        name: "Health Insurance in Bangalore",
        link: "https://www.nivabupa.com/health-insurance/bangalore.html",
      },
    ],
    "Health Insurance Schemes": [
      {
        name: isMobile
          ? "Chief Ministers Comprehensive..."
          : "Chief Ministers Comprehensive Health Insurance Scheme",
        link: "https://www.nivabupa.com/chief-ministers-comprehensive-health-insurance-scheme.html",
      },
      {
        name: "Employee State Insurance Scheme",
        link: "https://www.nivabupa.com/employee-state-insurance-scheme.html",
      },
      {
        name: "Swasthya Sathi Scheme",
        link: "https://www.nivabupa.com/swasthya-sathi-scheme.html",
      },
      {
        name: "Swasthya Sathi",
        link: "https://www.nivabupa.com/swasthya-sathi-scheme.html",
      },
      {
        name: "Pradhan Mantri Matru Vandana Yojna",
        link: "https://www.nivabupa.com/pradhan-mantri-matru-vandana-yojana.html",
      },
      {
        name: "Government Health Insurance Scheme",
        link: "https://www.nivabupa.com/government-health-insurance-scheme.html",
      },
      {
        name: "Dr. YSR Aarogyasri Scheme",
        link: "https://www.nivabupa.com/dr-ysr-aarogyasri-scheme.html",
      },
      {
        name: "Pradhan Mantri Suraksha Bima Yojna",
        link: "https://www.nivabupa.com/pradhan-mantri-suraksha-bima-yojana.html",
      },
      {
        name: "Health Insurance Deductible",
        link: "https://www.nivabupa.com/health-insurance-deductible.html",
      },
      {
        name: "West Bengal Health Scheme",
        link: "https://www.nivabupa.com/west-bengal-health-scheme.html",
      },
      {
        name: "Third Party Administrator",
        link: "https://www.nivabupa.com/third-party-administrator.html",
      },
      {
        name: "Rashtriya Swasthya Bima Yojana",
        link: "https://www.nivabupa.com/rashtriya-swasthya-bima-yojana.html",
      },
      {
        name: "In Patient Vs Out Patient Hospitalization",
        link: "https://www.nivabupa.com/inpatient-vs-outpatient-hospitalisation.html",
      },
      {
        name: "Mukhyamantri Chiranjeevi Yojna",
        link: "https://www.nivabupa.com/mukhyamantri-chiranjeevi-yojana.html",
      },
      {
        name: "Arogya Sanjeevani Health Insurance",
        link: "https://www.nivabupa.com/arogya-sanjeevani-health-insurance.html",
      },
      {
        name: "Copay Health Insurance",
        link: "https://www.nivabupa.com/copay-health-insurance.html",
      },
      {
        name: "Cashless Health Insurance Scheme",
        link: "https://www.nivabupa.com/cashless-health-insurance.html",
      },
      {
        name: "Mukhyamantri Amrutum Yojna",
        link: "https://www.nivabupa.com/mukhyamantri-amrutum-yojana.html",
      },
      {
        name: "PMMVY Login",
        link: "https://www.nivabupa.com/govt-scheme-articles/pmmvy-login-details-and-its-benefits-in-hindi.html",
      },
      {
        name: "PMJJBY Policy Status",
        link: "https://www.nivabupa.com/govt-scheme-articles/how-to-check-pmjjby-policy-status-.html",
      },
      {
        name: "Swasthya Sathi Card",
        link: "https://www.nivabupa.com/govt-scheme-articles/swasthya-sathi-card-download.html",
      },
      {
        name: "PMSBY",
        link: "https://www.nivabupa.com/govt-scheme-articles/pmsby-kya-hai-in-hindi.html",
      },
      {
        name: "ABHA Card Download",
        link: "https://www.nivabupa.com/health-insurance-articles/how-to-download-abha-card-online.html",
      },
      {
        name: "PMJJBY",
        link: "https://www.nivabupa.com/govt-scheme-articles/what-is-pmjjby-and-its-benefits-in-hindi.html",
      },
      {
        name: "Ayushman Card",
        link: "https://www.nivabupa.com/govt-scheme-articles/ayushman-card-kya-hota-hai-and-its-benefits-in-hindi.html",
      },
      {
        name: "PMMVY 2.0",
        link: "https://www.nivabupa.com/govt-scheme-articles/pmmvy-2-0-explained.html",
      },
      {
        name: "Ayushman Vay Vandana Card",
        link: "https://www.nivabupa.com/govt-scheme-articles/jaanein-ayushman-vay-vandana-card-in-hindi.html",
      },
      {
        name: "PMMVY NIC IN रजिस्ट्रेशन",
        link: "https://www.nivabupa.com/govt-scheme-articles/pmmvy-login-details-and-its-benefits-in-hindi.html",
      },
      {
        name: "PMMVY 2.0 लॉगिन",
        link: "https://www.nivabupa.com/govt-scheme-articles/pmmvy-login-details-and-its-benefits-in-hindi.html",
      },
    ],
    "Travel Insurance": [
      {
        name: "Travel Insurance",
        link: "https://www.nivabupa.com/travel-insurance.html",
      },
      {
        name: "International Travel Insurance",
        link: "https://www.nivabupa.com/travel-insurance/international-travel-insurance.html",
      },
      {
        name: "Student Travel Insurance",
        link: "https://www.nivabupa.com/travel-insurance/student-travel-insurance.html",
      },
      {
        name: "Travel Insurance USA",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-usa.html",
      },
      {
        name: "Travel Insurance Canada",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-canada.html",
      },
      {
        name: "Travel Insurance Thailand",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-thailand.html",
      },
      {
        name: "Travel Insurance Germany",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-germany.html",
      },
      {
        name: "Travel Insurance Dubai",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-dubai.html",
      },
      {
        name: "Travel Insurance Bali",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-bali.html",
      },
      {
        name: "Travel Insurance Australia",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-australia.html",
      },
      {
        name: "Travel Insurance Schengen",
        link: "https://www.nivabupa.com/travel-insurance/schengen-travel-insurance.html",
      },
      {
        name: "Travel Insurance Singapore",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-singapore.html",
      },
      {
        name: "Travel Insurance UK",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-uk.html",
      },
      {
        name: "Travel Insurance Vietnam",
        link: "https://www.nivabupa.com/travel-insurance/travel-insurance-vietnam.html",
      },
      {
        name: "Malaysia Tourist Places",
        link: "https://www.nivabupa.com/travel-insurance-articles/exploring-the-best-tourist-places-in-malaysia.html",
      },
      {
        name: "Thailand Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/a-comprehensive-guide-to-obtaining-a-thailand-visa-for-indian-travellers.html",
      },
      {
        name: "Canada Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/know-everything-about-canada-visa-for-indians.html",
      },
      {
        name: "Bali Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/bali-visa-for-indians.html",
      },
      {
        name: "ECR and Non ECR Passport",
        link: "https://www.nivabupa.com/travel-insurance-articles/what-is-a-non-ecr-passport.html",
      },
      // {
      //   name: "Qatar Visa Status",
      //   link: "https://www.nivabupa.com/travel-insurance-articles/qatar-visa-status.html",
      // },
      // {
      //   name: "USA Visa",
      //   link: "https://www.nivabupa.com/travel-insurance-articles/usa-visa-for-indians-everything-you-need-to-know.html",
      // },
      {
        name: "US Visa Appointment",
        link: "https://www.nivabupa.com/travel-insurance-articles/all-you-need-to-know-about-your-us-visa-appointment.html",
      },
      {
        name: "Check Saudi Visa Status",
        link: "https://www.nivabupa.com/travel-insurance-articles/how-to-check-saudi-arabia-visa-status-online.html",
      },
      {
        name: "South Korea Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/south-korea-visa-requirements.html",
      },
      {
        name: "Dubai Work Visa for Indian",
        link: "https://www.nivabupa.com/travel-insurance-articles/steps-for-indians-applying-for-a-work-visa-in-dubai.html",
      },
      {
        name: "New Zealand Visa Status",
        link: "https://www.nivabupa.com/travel-insurance-articles/how-to-check-your-new-zealand-visa-status.html",
      },
      {
        name: "Singapore Transit Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/singapore-transit-visa-permit.html",
      },
      {
        name: "Netherlands Work Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/netherlands-work-visa-for-indians.html",
      },
      {
        name: "File Number in Passport",
        link: "https://www.nivabupa.com/travel-insurance-articles/step-by-step-guide-locating-the-file-number-on-your-passport.html",
      },
      {
        name: "How to Renew a Passport Online",
        link: "https://www.nivabupa.com/travel-insurance-articles/how-to-renew-a-passport-online-in-2025.html",
      },
      {
        name: "RPO",
        link: "https://www.nivabupa.com/travel-insurance-articles/how-to-change-rpo-for-your-passport.html",
      },
      {
        name: "US Work Visa for Indians",
        link: "https://www.nivabupa.com/travel-insurance-articles/us-work-visa-for-indians.html",
      },
      {
        name: "Passport Seva Kendra",
        link: "https://www.nivabupa.com/travel-insurance-articles/passport-seva-kendra-meaning-roles-responsibilities-protocols.html",
      },
      // {
      //   name: "Vietnam Visa",
      //   link: "https://www.nivabupa.com/travel-insurance-articles/vietnam-visa-for-indians-application-process-and-eligibility-criteria.html",
      // },
      // {
      //   name: "USA H1B Work Visa",
      //   link: "https://www.nivabupa.com/travel-insurance-articles/usa-h1b-work-visa.html",
      // },
    ],
    "Become An Agent": [
      {
        name: "Insurance Agent",
        link: "https://www.nivabupa.com/become-an-agent-portal.html",
      },
      {
        name: "Insurance Advisor",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-an-insurance-advisor-and-how-to-become-an-advisor-in-india.html",
      },
      {
        name: "Licensed Insurance Agent",
        link: "https://www.nivabupa.com/health-insurance-articles/insurance-agent-license-renewal-process-in-india.html",
      },
      {
        name: "Health Insurance Consultant",
        link: "https://www.nivabupa.com/health-insurance-articles/benefits-of-consulting-a-health-insurance-agent.html",
      },
      {
        name: "POSP Insurance Agent",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-posp-insurance-agent.html",
      },
      {
        name: "IRDA Certificate Download",
        link: "https://www.nivabupa.com/health-insurance-articles/irda-certificate-download-step-by-step-guide-for-insurance-agents.html",
      },
      {
        name: "IC 38 Exam",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-the-ic-examination-how-to-clear-it.html",
      },
      {
        name: "Insurance Agent vs POSP",
        link: "https://www.nivabupa.com/health-insurance-articles/difference-between-insurance-agent-and-posp.html",
      },
      {
        name: "IRDA Exam Syllabus",
        link: "https://www.nivabupa.com/health-insurance-articles/irda-exam-syllabus-for-insurance-agent-complete-guide.html",
      },
      {
        name: "IRDAI Agent Locator",
        link: "https://www.nivabupa.com/health-insurance-articles/irdai-agent-locator-what-it-is-and-how-to-use-it-effectively.html",
      },
      {
        name: "IRDA exam fee",
        link: "https://www.nivabupa.com/health-insurance-articles/complete-guide-to-irda-insurance-agent-exam-fees.html",
      },
    ],
    "Group Health Insurance": [
      {
        name: "Startup Health Insurance",
        link: "https://www.nivabupa.com/startup-health-insurance.html",
      },
      {
        name: "Commercial Health Insurance",
        link: "https://www.nivabupa.com/corporate-insurance-articles/what-is-commercial-health-insurance.html",
      },
      {
        name: "Corporate insurance vs personal insurance",
        link: "https://www.nivabupa.com/corporate-insurance-articles/corporate-health-insurance-vs-personal-health-insurance.html",
      },
      {
        name: "Group Personal Accident Insurance",
        link: "https://www.nivabupa.com/corporate-insurance-articles/why-group-personal-accident-insurance-is-a-must-have-for-employees.html",
      },
      {
        name: "Group Travel Insurance",
        link: "https://www.nivabupa.com/corporate-group-health-insurance/group-travel-insurance.html",
      },
      {
        name: "Employer Employee Insurance",
        link: "https://www.nivabupa.com/corporate-group-health-insurance/employer-employee-insurance.html",
      },
      {
        name: "Maternity Leave Rules",
        link: "https://www.nivabupa.com/corporate-insurance-articles/maternity-leave-rules-in-india.html",
      },
      {
        name: "Group Health Insurance CSR",
        link: "https://www.nivabupa.com/corporate-insurance-articles/group-health-insurance-claim-settlement-ratio.html",
      },
      {
        name: "Employees State Insurance Corporation",
        link: "https://www.nivabupa.com/corporate-insurance-articles/everything-you-need-to-know-about-esic-and-its-benefits.html",
      },
      {
        name: "Workers Compensation Insurance",
        link: "https://www.nivabupa.com/corporate-insurance-articles/workers-compensation-insurance-explained-process-benefits-and-responsibility.html",
      },
      {
        name: "Group Health Insurance Tax",
        link: "https://www.nivabupa.com/corporate-insurance-articles/group-health-insurance-tax-benefit-for-employers-and-employees.html",
      },
      {
        name: "Group OPD Coverage",
        link: "https://www.nivabupa.com/corporate-group-health-insurance/opd-coverage-in-health-insurance.html",
      },
      {
        name: "Employee Benefits Programme",
        link: "https://www.nivabupa.com/corporate-insurance-articles/employee-benefits-programme.html",
      },
      {
        name: "How to Claim ESI Amount",
        link: "https://www.nivabupa.com/corporate-insurance-articles/step-by-step-guide-to-claim-your-esi-amount.html",
      },
      {
        name: "Group Insurance vs. Individual Insurance",
        link: "https://www.nivabupa.com/corporate-insurance-articles/group-insurance-vs-individual-insurance-commission-comparison.html",
      },
      {
        name: "Employee Benefits Liability",
        link: "https://www.nivabupa.com/corporate-insurance-articles/understanding-employee-benefits-liability.html",
      },
    ],
    "Top Hospitals": [
      {
        name: "Best Hospitals in Chennai",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-in-chennai.html",
      },
      {
        name: "Top Hospitals in Delhi",
        link: "https://www.nivabupa.com/health-insurance-articles/top-hospitals-in-delhi.html",
      },
      {
        name: "Best Hospitals in Gurgaon",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-in-gurgaon.html",
      },
      {
        name: "Best Hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-in-india.html",
      },
      {
        name: "Top 10 Hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/top-10-hospitals-in-india.html",
      },
      {
        name: "Best Hospitals in Hyderabad",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospital-in-hyderabad.html",
      },
      {
        name: "Best Hospitals in Kolkata",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-in-kolkata.html",
      },
      {
        name: "Best cancer hospitals in Bangalore",
        link: "https://www.nivabupa.com/health-insurance-articles/best-cancer-hospitals-in-bangalore.html",
      },
      {
        name: "Best cancer hospitals in Hyderabad",
        link: "https://www.nivabupa.com/health-insurance-articles/best-cancer-hospitals-in-hyderabad.html",
      },
      {
        name: "Best cancer hospitals in Mumbai",
        link: "https://www.nivabupa.com/health-insurance-articles/best-cancer-hospitals-in-mumbai.html",
      },
      {
        name: "Best cancer hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-for-cancer-india.html",
      },
      {
        name: "Top 10 cancer hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/top-10-cancer-hospitals-in-india.html",
      },
      {
        name: "Top 10 cancer hospital in Delhi",
        link: "https://www.nivabupa.com/health-insurance-articles/top-10-cancer-hospitals-in-delhi.html",
      },
      {
        name: "Multi Speciality Hospitals in Mumbai",
        link: "https://www.nivabupa.com/health-insurance-articles/multi-speciality-hospitals-in-mumbai.html",
      },
      {
        name: "Multi Speciality Hospitals in Chennai",
        link: "https://www.nivabupa.com/health-insurance-articles/multi-speciality-hospitals-in-chennai.html",
      },
      {
        name: "Multi Speciality Hospitals in Hyderabad",
        link: "https://www.nivabupa.com/health-insurance-articles/multi-speciality-hospital-in-hyderabad.html",
      },
      {
        name: "Super Speciality Hospitals in Delhi",
        link: "https://www.nivabupa.com/health-insurance-articles/super-speciality-hospitals-in-delhi.html",
      },
      {
        name: "Best Liver Hospitals in Delhi",
        link: "https://www.nivabupa.com/health-insurance-articles/best-liver-hospitals-in-delhi.html",
      },
      {
        name: "Best Liver Hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/best-liver-hospitals-in-india.html",
      },
      {
        name: "Best Kidney Hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/best-hospitals-for-kidney-in-india.html",
      },
      {
        name: "Best Heart hospitals in Bangalore",
        link: "https://www.nivabupa.com/health-insurance-articles/best-heart-hospitals-in-bangalore.html",
      },
      {
        name: "Best Heart hospitals in India",
        link: "https://www.nivabupa.com/health-insurance-articles/best-heart-hospitals-in-india.html",
      },
      {
        name: "Best Heart hospitals in Kolkata",
        link: "https://www.nivabupa.com/health-insurance-articles/best-heart-hospitals-in-kolkata.html",
      },
      {
        name: "Best Heart hospitals in Delhi",
        link: "https://www.nivabupa.com/health-insurance-articles/best-heart-hospitals-in-delhi.html",
      },
    ],
    Others: [
      {
        name: "Top Up Health Insurance Policy",
        link: "https://www.nivabupa.com/health-insurance/top-up-health-insurance-policy.html",
      },
      {
        name: "Corporate Health Insurance",
        link: "https://www.nivabupa.com/corporate-group-health-insurance.html",
      },
      {
        name: "Health Card",
        link: "https://www.nivabupa.com/health-insurance/health-card.html",
      },
      {
        name: "Section 80d of Income Tax Act",
        link: "https://www.nivabupa.com/health-insurance/section-80d-deductions.html",
      },
      {
        name: "Ayushman Bharat",
        link: "https://www.nivabupa.com/govt-scheme/ayushman-bharat-yojana.html",
      },
      {
        name: "Health Insurance Portability",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-health-insurance-portability.html",
      },
      {
        name: "GoActive Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/goactive-family-floater.html",
      },
      {
        name: "Health Companion Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/health-companion-family-floater.html",
      },
      {
        name: "Health Premia Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/health-premia-family-floater.html",
      },
      {
        name: "Health Pulse Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/health-pulse-family-floater.html",
      },
      {
        name: "Health Recharge Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/health-recharge-family-floater.html",
      },
      {
        name: "Heartbeat Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/heart-beat-family-floater.html",
      },
      {
        name: "Money Saver Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/money-saver.html",
      },
      {
        name: "Saral Suraksha Bima Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/saral-suraksha-bima.html",
      },
      {
        name: "Senior Citizen Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
      },
      {
        name: "Super Saver Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/super-saver-family-floater.html",
      },
      {
        name: "Corona Kavach Family Floater Plan",
        link: "https://www.nivabupa.com/family-health-insurance-plans/corona-kavach-family-floater.html",
      },
      {
        name: "Hospital Cash Insurance",
        link: "https://www.nivabupa.com/hospital-cash-insurance.html",
      },
      {
        name: "Cashless Health Insurance",
        link: "https://www.nivabupa.com/cashless-health-insurance.html",
      },
      {
        name: "Health Companion Price revision",
        link: "https://www.nivabupa.com/content/dam/nivabupa/PDF/websitenotes/Health%20Companion%20v7_Webiste%20Note.pdf",
      },
      {
        name: "Heartbeat Price revision",
        link: "https://www.nivabupa.com/content/dam/nivabupa/PDF/websitenotes/Heart%20Beat_Note%20for%20website.pdf",
      },
      {
        name: "ReAssure Price revision",
        link: "https://www.nivabupa.com/content/dam/nivabupa/PDF/websitenotes/ReAssure_Note%20for%20website.pdf",
      },
      {
        name: "Gst Refund for NRI on Health Insurance Premium",
        link: "https://www.nivabupa.com/tax-saving-articles/nri-tax-savings-health-insurance-india.html",
      },
      {
        name: "Health Insurance Tax Deductible",
        link: "https://www.nivabupa.com/health-insurance-articles/is-medical-insurance-tax-deductible.html",
      },
    ],
    "COVID" : [
      {
        name: "Omicron",
        link: "https://www.nivabupa.com/covid-19-omicron.html",
      },
      {
        name: "Coronavirus Health Insurance",
        link: "https://www.nivabupa.com/coronavirus-health-insurance.html",
      },
      {
        name: "Norovirus",
        link: "https://www.nivabupa.com/health-insurance/norovirus.html",
      },
      {
        name: "COVID Variants (NB.1.8.1 and LF.7)",
        link: "https://www.nivabupa.com/disease-articles/new-covid-new-subvariants-nb-181-lf7-detection-in-india.html",
      },
    ],
    "Health & Wellness": [
      {
        name: "PCOD",
        link: "https://www.nivabupa.com/disease-articles/understanding-pcod-problems-symptoms-causes-and-treatments.html",
      },
      {
        name: "PCOD Problems Symptoms",
        link: "https://www.nivabupa.com/disease-articles/understanding-pcod-problems-symptoms-causes-and-treatments.html",
      },
      {
        name: "Stomach Infection",
        link: "https://www.nivabupa.com/disease-articles/stomach-infection-causes-symptoms-and-home-remedies.html",
      },
      {
        name: "Stomach Infection symptoms",
        link: "https://www.nivabupa.com/disease-articles/stomach-infection-causes-symptoms-and-home-remedies.html",
      },
      {
        name: "Home remedies for Stomach Infection",
        link: "https://www.nivabupa.com/disease-articles/stomach-infection-causes-symptoms-and-home-remedies.html",
      },
      {
        name: "Hypertension definition",
        link: "https://www.nivabupa.com/disease-articles/hypertension-definition-medical-insights-and-clarifications.html",
      },
      {
        name: "How to Control Sugar",
        link: "https://www.nivabupa.com/disease-articles/how-to-control-sugar.html",
      },
      {
        name: "Typhoid in Hindi",
        link: "https://www.nivabupa.com/disease-articles/what-is-typhoid-in-hindi.html",
      },
      {
        name: "Blood sugar symptoms",
        link: "https://www.nivabupa.com/disease-articles/blood-sugar-symptoms-in-hindi.html",
      },
      {
        name: "Typhoid symptoms in hindi",
        link: "https://www.nivabupa.com/disease-articles/what-is-typhoid-in-hindi.html",
      },
      {
        name: "Low sugar symptoms",
        link: "https://www.nivabupa.com/disease-articles/low-sugar-level-symptoms-causes-manage-hypoglycemia.html",
      },
      {
        name: "ब्लड शुगर के लक्षण",
        link: "https://www.nivabupa.com/disease-articles/blood-sugar-symptoms-in-hindi.html",
      },
      {
        name: "Pregnancy me kya kare",
        link: "https://www.nivabupa.com/health-insurance-articles/what-to-do-during-pregnancy-in-hindi.html",
      },
      {
        name: "Open heart surgery cost",
        link: "https://www.nivabupa.com/health-insurance-articles/what-to-do-during-pregnancy-in-hindi.html",
      },
      {
        name: "Blood infection symptoms in hindi",
        link: "https://www.nivabupa.com/disease-articles/symptoms-of-blood-infection-in-hindi.html",
      },
      {
        name: "BP badhne ke karan",
        link: "https://www.nivabupa.com/health-insurance-articles/high-blood-pressure-in-hindi.html",
      },
      {
        name: "Khansi ka gharelu upay",
        link: "https://www.nivabupa.com/disease-articles/cough-types-symptoms-home-remedies-in-hindi.html",
      },
      {
        name: "Black Coffee Benefits in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/black-coffee-benefits-and-drawbacks-in-hindi.html",
      },
      {
        name: "Menopause Symptoms in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/menopause-symptoms-of-stopping-menstruation-in-hindi.html",
      },
      {
        name: "Benefits of Neem in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/10-benefits-of-neem-in-hindi.html",
      },
      {
        name: "Benefits of Fenugreek Water in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/benefits-and-disadvantages-of-fenugreek-water-in-hindi.html",
      },
      {
        name: "Parkinsons Disease",
        link: "https://www.nivabupa.com/disease-articles/10-facts-about-parkinson-disease-you-should-know.html",
      },
      {
        name: "Anxiety",
        link: "https://www.nivabupa.com/disease-articles/anxiety-symptoms-and-treatment-options-in-hindi.html",
      },
      {
        name: "Parkinsons Disease in Hindi",
        link: "https://www.nivabupa.com/disease-articles/parkinsons-disease-in-hindi.html",
      },
      {
        name: "Shilajit ke Fayde",
        link: "https://www.nivabupa.com/health-wellness-articles/shilajit-benefits-in-hindi.html",
      },
      {
        name: "Vitamin B Complex Tablet Uses In Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/vitamin-b-complex-tablet-uses-in-hindi.html",
      },
      {
        name: "Limcee tablet uses in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/kya-hai-limcee-tablet-uses-in-hindi.html",
      },
      {
        name: "OPD Full Form",
        link: "https://www.nivabupa.com/health-insurance-articles/what-is-opd-full-form-in-medical-insurance.html",
      },
      {
        name: "Anxiety in Hindi",
        link: "https://www.nivabupa.com/disease-articles/anxiety-symptoms-and-treatment-options-in-hindi.html",
      },
      {
        name: "SGPT Test in Hindi",
        link: "https://www.nivabupa.com/disease-articles/sgot-and-sgpt-test-in-hindi.html",
      },
      {
        name: "SGOT Test in Hindi",
        link: "https://www.nivabupa.com/disease-articles/sgot-and-sgpt-test-in-hindi.html",
      },
      {
        name: "Trauma in Hindi",
        link: "https://www.nivabupa.com/disease-articles/what-is-trauma-in-hindi.html",
      },
      {
        name: "TPA Full Form",
        link: "https://www.nivabupa.com/corporate-insurance-articles/tpa-full-form-in-medical-insurance.html",
      },
      {
        name: "शिलाजीत के फायदे हिंदी",
        link: "https://www.nivabupa.com/health-wellness-articles/shilajit-benefits-in-hindi.html",
      },
      {
        name: "Weight Gain Diet in Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/weight-gain-diet-in-hindi.html",
      },
      {
        name: "Sat Isabgol Uses In Hindi",
        link: "https://www.nivabupa.com/health-wellness-articles/isabgol-ke-fayde-in-hindi.html",
      },
    ],
    "Calculator" : [
      {
        name: "BMI Calculator",
        link: "https://www.nivabupa.com/calculator/bmi-calculator.html",
      },
      {
        name: "Pregnancy Calculator",
        link: "https://www.nivabupa.com/calculator/pregnancy-calculator.html",
      },
       {
        name: "Pregnancy Calendar Based on Conception Date",
        link: "https://www.nivabupa.com/health-wellness-articles/pregnancy-conception-date-calculator.html",
      },
      {
        name: "Pregnancy Conception Date Calculator",
        link: "https://www.nivabupa.com/health-wellness-articles/pregnancy-conception-date-calculator.html",
      },
      {
        name: "Last Menstrual Period Calculator",
        link: "https://www.nivabupa.com/health-wellness-articles/last-menstrual-period-calculator.html",
      },
    ],
  };

  const finalSearchData = searchesData || searches;
  return (
    <div id="footer-container" className="flex flex-col mt-8 mb-4">
      {Object.keys(finalSearchData).map((key) => (
        <SearchJSX
          key={key}
          heading={key}
          array={finalSearchData[key]}
          newDesignConfig={newDesignConfig}
        />
      ))}
    </div>
  );
};

export default PopularSearches;
